import angular from 'angular';
import reportSchedule from './reportSchedule';
import directive from './report-schedules.directive';
import controller from './report-schedules.controller';


export default angular.module('app.components.reports.scheduledReports.reportSchedules', [
  reportSchedule
])
  .directive('srReportSchedules', directive)
  .controller('SRReportSchedulesController', controller)
  .name;

console.log('app.components.reports.scheduledReports.reportSchedules created');
